import useAPI from '@/hooks/useAPI';
import PersonRepository from '@/repositories/PersonRepository';

const useTimeZones = (enabled = true) => {
  const personRepository = PersonRepository();

  return useAPI({
    queryKey: ['getTimeZones'],
    queryFn: async () => {
      return await personRepository.getTimeZones();
    },
    enabled
  });
};

export default useTimeZones;
